export default [
  {
    id: "developpeurFrontEnd",
    type: "card",
    data: {
      label: "Développeur.se Front-end",
      backgroundColor: "#fff",
      src: "https://images.unsplash.com/photo-1580927752452-89d86da3fa0a?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      details: "La sagesse réside dans la spécialisation, et non dans la maîtrise de tout.",
      buttonText: "Allons-y !",
      onClick: () => document.getElementById("prog").click(),
    },
    isConnectable: true,
    position: { x: 640, y: -350 },
  },
  {
    id: "langageDeProgrammation",
    type: "card",
    data: {
      label: "Langages de Programmation  ",
      backgroundColor: "#f9ff44",
    },
    isConnectable: true,
    position: { x: -420, y: -80 },
  },

  {
    id: "javaScript",
    type: "rectangle",
    data: {
      label: "JavaScript",
      backgroundColor: "#f9ff22",
    },
    isConnectable: true,
    position: { x: -110, y: 240 },
  },
  {
    id: "typeScript",
    type: "rectangle",
    data: {
      label: "TypeScript",
      backgroundColor: "#ffdd00",
    },
    isConnectable: true,
    position: { x: -110, y: 370 },
  },
  {
    id: "html",
    type: "rectangle",
    data: {
      label: "HTML",
      backgroundColor: "#f9ff22",
    },
    isConnectable: true,
    position: { x: -660, y: 240 },
  },
  {
    id: "css",
    type: "rectangle",
    data: {
      label: "CSS",
      backgroundColor: "#f9ff22",
    },
    isConnectable: true,
    position: { x: -380, y: 240 },
  },
  {
    id: "scss",
    type: "circle",
    data: {
      label: "SCSS",
      backgroundColor: "#f9ff66",
    },
    isConnectable: true,
    position: { x: -590, y: 380 },
  },
  {
    id: "sass",
    type: "circle",
    data: {
      label: "SASS",
      backgroundColor: "#f9ff66",
    },
    isConnectable: true,
    position: { x: -470, y: 490 },
  },
  {
    id: "less",
    type: "circle",
    data: {
      label: "LESS",
      backgroundColor: "#f9ff66",
    },
    isConnectable: true,
    position: { x: -210, y: 430 },
  },

  {
    id: "bibliothequesFrameWorkJS",
    type: "card",
    data: {
      label: "Bibliothèques et Frameworks JavaScript",
      backgroundColor: "#00faff",
    },
    isConnectable: true,
    position: { x: 700, y: 300 },
  },
  {
    id: "LibrariesDeTests",
    type: "card",
    data: {
      label: "Libraries de Tests",
      backgroundColor: "#45f180",
    },
    isConnectable: true,
    position: { x: -400, y: -700 },
  },
  {
    id: "librariesUi",
    type: "card",
    data: {
      label: "Libraries UI",
      backgroundColor: "#FF7F00",
    },
    isConnectable: true,
    position: { x: 220, y: -1200 },
  },

  {
    id: "react",
    type: "rectangle",
    data: {
      label: "React",
      backgroundColor: "#00faff",
    },
    isConnectable: true,
    position: { x: 180, y: 500 },
  },

  {
    id: "angular",
    type: "rectangle",
    data: {
      label: "Angular",
      backgroundColor: "rgb(180 40 60)",
    },
    isConnectable: true,
    position: { x: 620, y: 700 },
  },
  {
    id: "angularCli",
    type: "rectangle",
    data: {
      label: "Angular CLI",
      backgroundColor: "rgb(180 40 100)",
    },
    isConnectable: true,
    position: { x: 450, y: 870 },
  },
  {
    id: "angularMaterial",
    type: "rectangle",
    data: {
      label: "Ang. Material",
      backgroundColor: "rgb(210 40 100)",
    },
    isConnectable: true,
    position: { x: 620, y: 990 },
  },
  {
    id: "vue",
    type: "rectangle",
    data: {
      label: "Vue JS",
      backgroundColor: "#42b883",
    },
    isConnectable: true,
    position: { x: 900, y: 700 },
  },
  {
    id: "vueCli",
    type: "rectangle",
    data: {
      label: "Vue CLI",
      backgroundColor: "#77b899",
    },
    isConnectable: true,
    position: { x: 1070, y: 870 },
  },
  {
    id: "vueNative",
    type: "rectangle",
    data: {
      label: "Vue Native",
      backgroundColor: "#77b899",
    },
    isConnectable: true,
    position: { x: 900, y: 990 },
  },
  {
    id: "svelte",
    type: "rectangle",
    data: {
      label: "Svelte",
      backgroundColor: "#ca3e3e",
    },
    isConnectable: true,
    position: { x: 1300, y: 500 },
  },
  {
    id: "svelteKit",
    type: "rectangle",
    data: {
      label: "Svelte Kit",
      backgroundColor: "#aa6e6e",
    },
    isConnectable: true,
    position: { x: 1170, y: 670 },
  },
  {
    id: "svelteNative",
    type: "rectangle",
    data: {
      label: "Svelte Native",
      backgroundColor: "#aa6e6e",
    },
    isConnectable: true,
    position: { x: 1300, y: 840 },
  },
  {
    id: "svelteElectron",
    type: "rectangle",
    data: {
      label: "Svelte Electron",
      backgroundColor: "#aa6e6e",
    },
    isConnectable: true,
    position: { x: 1440, y: 670 },
  },

  {
    id: "reactjs",
    type: "rectangle",
    data: {
      label: "React JS/TS",
      backgroundColor: "#94fdff",
    },
    isConnectable: true,
    position: { x: -40, y: 670 },
  },

  {
    id: "next",
    type: "rectangle",
    data: {
      label: "Next JS",
      backgroundColor: "#94fdff",
    },
    isConnectable: true,
    position: { x: 70, y: 780 },
  },
  {
    id: "reactNative",
    type: "rectangle",
    data: {
      label: "React Native",
      backgroundColor: "#94fdff",
    },
    isConnectable: true,
    position: { x: 180, y: 880 },
  },
  {
    id: "gatsby",
    type: "rectangle",
    data: {
      label: "Gatsby",
      backgroundColor: "#94fdff",
    },
    isConnectable: true,
    position: { x: 340, y: 710 },
  },
  {
    id: "librariesCSS",
    type: "card",
    data: {
      label: "Libraries CSS",
      backgroundColor: "#ff78d1",
    },
    isConnectable: true,
    position: { x: -420, y: 680 },
  },
  {
    id: "bootstrap",
    type: "circle",
    data: {
      label: "Bootstrap",
      backgroundColor: "#ffbbe7",
    },
    isConnectable: true,
    position: { x: -610, y: 840 },
  },
  {
    id: "tailwind",
    type: "circle",
    data: {
      label: "Tailwind",
      backgroundColor: "#ffbbe7",
    },
    isConnectable: true,
    position: { x: -480, y: 940 },
  },

  {
    id: "materialize",
    type: "circle",
    data: {
      label: "Materialize",
      backgroundColor: "#ffbbe7",
    },
    isConnectable: true,
    position: { x: -350, y: 1040 },
  },
  {
    id: "bulma",
    type: "circle",
    data: {
      label: "Bulma",
      backgroundColor: "#ffbbe7",
    },
    isConnectable: true,
    position: { x: -210, y: 840 },
  },
  {
    id: "jest",
    type: "circle",
    data: {
      label: "Jest",
      backgroundColor: "#76fb91",
    },
    isConnectable: true,
    position: { x: -640, y: -520 },
  },
  {
    id: "testingLibrary",
    type: "circle",
    data: {
      label: "Testing Library",
      backgroundColor: "#76fb91",
    },
    isConnectable: true,
    position: { x: -500, y: -420 },
  },
  {
    id: "jasmine",
    type: "circle",
    data: {
      label: "Jasmine",
      backgroundColor: "#76fb91",
    },
    isConnectable: true,
    position: { x: -330, y: -320 },
  },
  {
    id: "enzyme",
    type: "circle",
    data: {
      label: "Enzyme",
      backgroundColor: "#76fb91",
    },
    isConnectable: true,
    position: { x: -210, y: -420 },
  },
  {
    id: "cypress",
    type: "circle",
    data: {
      label: "Cypress",
      backgroundColor: "#76fb91",
    },
    isConnectable: true,
    position: { x: -80, y: -520 },
  },
  {
    id: "materialUi",
    type: "circle",
    data: {
      label: "Material-UI",
      backgroundColor: "#FFCB60",
    },
    isConnectable: true,
    position: { x: -100, y: -1020 },
  },
  {
    id: "daisyUi",
    type: "circle",
    data: {
      label: "Daisy UI",
      backgroundColor: "#FFCB60",
    },
    isConnectable: true,
    position: { x: 40, y: -920 },
  },
  {
    id: "antDesign",
    type: "circle",
    data: {
      label: "Ant Design",
      backgroundColor: "#FFCB60",
    },
    isConnectable: true,
    position: { x: 160, y: -810 },
  },
  {
    id: "chakraUi",
    type: "circle",
    data: {
      label: "Chakra UI",
      backgroundColor: "#FFCB60",
    },
    isConnectable: true,
    position: { x: 290, y: -700 },
  },
  {
    id: "foundation",
    type: "circle",
    data: {
      label: "Foundation",
      backgroundColor: "#FFCB60",
    },
    isConnectable: true,
    position: { x: 420, y: -860 },
  },
  {
    id: "semanticUi",
    type: "circle",
    data: {
      label: "Semantic UI",
      backgroundColor: "#FFCB60",
    },
    isConnectable: true,
    position: { x: 550, y: -1020 },
  },
  {
    id: "pratiquesFrontEnd",
    type: "card",
    data: {
      label: "Pratiques Front-end Craft",
      backgroundColor: "#58FAAC",
    },
    isConnectable: true,
    position: { x: 1180, y: -1200 },
  },

  {
    id: "responsiveDesign",
    type: "rectangle",
    data: {
      label: "Responsive Design",
      backgroundColor: "#A9F5D0",
    },
    isConnectable: true,
    position: { x: 794, y: -1041 },
  },
  {
    id: "ergonomie",
    type: "rectangle",
    data: {
      label: "Ergonomie",
      backgroundColor: "#A9F5D0",
    },
    isConnectable: true,
    position: { x: 869, y: -950 },
  },
  {
    id: "atomiqueDesign",
    type: "rectangle",
    data: {
      label: "Atomique Design",
      backgroundColor: "#A9F5D0",
    },
    isConnectable: true,
    position: { x: 987, y: -866 },
  },

  {
    id: "principeSolid",
    type: "rectangle",
    data: {
      label: "Principes SOLID",
      backgroundColor: "#A9F5D0",
    },
    isConnectable: true,
    position: { x: 1085, y: -764 },
  },
  {
    id: "cleanArchitecture",
    type: "rectangle",
    data: {
      label: "Clean Architecture",
      backgroundColor: "#A9F5D0",
    },
    isConnectable: true,
    position: { x: 1211, y: -656 },
  },
  {
    id: "testsUnitaire",
    type: "rectangle",
    data: {
      label: "Tests Unitaires",
      backgroundColor: "#A9F5D0",
    },
    isConnectable: true,
    position: { x: 1338, y: -749 },
  },
  {
    id: "codeReview",
    type: "rectangle",
    data: {
      label: "Code Review",
      backgroundColor: "#A9F5D0",
    },
    isConnectable: true,
    position: { x: 1461, y: -830 },
  }, {
    id: "tdd",
    type: "rectangle",
    data: {
      label: "TDD",
      backgroundColor: "#A9F5D0",
    },
    isConnectable: true,
    position: { x: 1579, y: -895 },
  },
  {
    id: "bdd",
    type: "rectangle",
    data: {
      label: "BDD",
      backgroundColor: "#A9F5D0",
    },
    isConnectable: true,
    position: { x: 1686, y: -965 },
  },
  
 
  
  {
    id: "ddd",
    type: "rectangle",
    data: {
      label: "DDD",
      backgroundColor: "#A9F5D0",
    },
    isConnectable: true,
    position: { x: 1789, y: -1041 },
  },
  

  {
    id: "uxtools",
    type: "card",
    data: {
      label: "UX modélisation",
      backgroundColor: "#FA5882",
    },
    isConnectable: true,
    position: { x: 1740, y: -700 },
  },
  {
    id: "figma",
    type: "circle",
    data: {
      label: "Figma ",
      backgroundColor: "#F5A9BC",
    },
    isConnectable: true,
    position: { x: 1450, y: -520 },
  },
  {
    id: "sketch",
    type: "circle",
    data: {
      label: "Sketch",
      backgroundColor: "#F5A9BC",
    },
    isConnectable: true,
    position: { x: 1620, y: -420 },
  },
  {
    id: "AdobeXD",
    type: "circle",
    data: {
      label: "Adobe XD",
      backgroundColor: "#F5A9BC",
    },
    isConnectable: true,
    position: { x: 1810, y: -320 },
  },
  {
    id: "inVisionStudio",
    type: "circle",
    data: {
      label: "InVision",
      backgroundColor: "#F5A9BC",
    },
    isConnectable: true,
    position: { x: 2000, y: -420 },
  },
  {
    id: "marvel",
    type: "circle",
    data: {
      label: "Marvel",
      backgroundColor: "#F5A9BC",
    },
    isConnectable: true,
    position: { x: 2180, y: -520 },
  },
  {
    id: "versioning",
    type: "card",
    data: {
      label: "Versioning",
      backgroundColor: "#A5DF00",
    },
    isConnectable: true,
    position: { x: 1630, y: -100 },
  },
  {
    id: "git",
    type: "circle",
    data: {
      label: "Git",
      backgroundColor: "#C8FE2E",
    },
    isConnectable: true,
    position: { x: 1550, y: 80 },
  },
  {
    id: "gitflow",
    type: "circle",
    data: {
      label: "Git Flow",
      backgroundColor: "#C8FE2E",
    },
    isConnectable: true,
    position: { x: 1700, y: 220 },
  },
  {
    id: "gitlab",
    type: "circle",
    data: {
      label: "GitLab",
      backgroundColor: "#C8FE2E",
    },
    isConnectable: true,
    position: { x: 1880, y: 80 },
  },
];
